import { FrontendApplication, FrontendApplicationContribution, WidgetManager } from '@theia/core/lib/browser';
import { Widget } from '@theia/core/lib/browser/widgets/widget';
import { inject, injectable } from '@theia/core/shared/inversify';
import { TooltipHostWidget } from './tooltip-host-widget';

@injectable()
export class TooltipHostContribution implements FrontendApplicationContribution {
    @inject(WidgetManager)
    protected readonly widgetManager!: WidgetManager;

    async onStart(_app: FrontendApplication): Promise<void> {
        const widget: TooltipHostWidget = await this.widgetManager.getOrCreateWidget(TooltipHostWidget.ID);
        if (!widget.isAttached) Widget.attach(widget, document.body);
    }
}
